import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ZodSchema } from 'zod';

type UpdateQueryParamProps = {
  name: string;
  value: string;
};

export default function useQueryParams(
  schema?: ZodSchema,
  baseCase?: Function
) {
  const search = useLocation().search;
  const navigate = useNavigate();
  const [ValidQuery, setValidQuery] = useState({});
  const urlSearchParams = new URLSearchParams(search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const location = useLocation();

  const isValidQueryParams = useCallback(async () => {
    if (schema) {
      const { success, data, error } = schema.safeParse(params);
      console.log('success', success);
      console.log('paramsvalid', params);

      if (success) {
        setValidQuery({ ...params });
      } else {
        baseCase?.();
      }
    } else {
      setValidQuery(params);
    }
  }, [search]);

  const updateQueryParam = (listOfQueries: UpdateQueryParamProps[]) => {
    const currentParams = new URLSearchParams(location.search);

    listOfQueries.forEach(({ name, value }) => {
      currentParams.set(name, value);
    });
    console.log('currentParams', currentParams?.toString());

    navigate(
      {
        pathname: location.pathname,
        search: currentParams.toString(),
      },
      { replace: true }
    );
  };

  const deleteQueryParam = (names: string[] = []) => {
    const searchParams = new URLSearchParams(location.search);
    names?.forEach((name) => {
      searchParams.delete(name);
    });
    console.log('searchParams', searchParams.toString());
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );
  };

  const replaceQueryParams = (opts: {
    delete?: string[];
    set?: UpdateQueryParamProps[];
  }) => {
    const searchParams = new URLSearchParams(location.search);
    opts.delete?.forEach((name) => searchParams.delete(name));
    opts.set?.forEach(({ name, value }) => searchParams.set(name, value));
    navigate(
      { pathname: location.pathname, search: searchParams.toString() },
      { replace: true }
    );
  };

  useEffect(() => {
    console.log('here test search', search);
    isValidQueryParams();
  }, [search]);

  return { ValidQuery, updateQueryParam, deleteQueryParam, replaceQueryParams };
}
